import consumer from './consumer'

export default consumer.subscriptions.create('CustomerSupportsChannel', {
  changeStatus(id) {
    this.perform('change_status', { id: id })
  },

  received(data) {
    const node = document.querySelector(`[data-csid=\"${data['id']}\"]`)
    if (!node) return

    const checkIcon = node.querySelector('[data-icon="check"]')
    const xmarkIcon = node.querySelector('[data-icon="xmark"]')

    node.querySelector('button').title = data['admin_user']
    node.className = ''

    switch (data['status']) {
      case 1:
        node.classList.add('bg-red-100')
        checkIcon.classList.add('hidden')
        xmarkIcon.classList.remove('hidden')
        break;
      case 2:
        node.classList.add('bg-green-100')
        checkIcon.classList.remove('hidden')
        xmarkIcon.classList.add('hidden')
        break;
      default:
        node.classList.add('bg-white', 'hover:bg-gray-50')
        checkIcon.classList.remove('hidden')
        xmarkIcon.classList.add('hidden')
    }
  }
})
